import { executeGetRequest, FetchConfig } from '@api/client';
import { createFetchDiagnosticsPath } from '@routing/apiUrls';
import { FetchDiagnosticsResponse } from '@models/diagnostics/FetchDiagnostics';

export const fetchDiagnostics = async (config?: FetchConfig) => {
    const result = await executeGetRequest<FetchDiagnosticsResponse>(createFetchDiagnosticsPath(), config);
    return result.data;
};
